import { Copy } from "lucide-react"
import { useState } from "react"

import { CheckIcon, type CheckIconHandle } from "@/components/ui/animated-icons/check"
import { usePlayOnMount } from "@/components/ui/animated-icons/use-play-on-mount"
import { cn } from "@/lib/utils"

import { Button } from "./button"

interface CopyButtonProps extends React.ComponentProps<typeof Button> {
  content: string
}

export function CopyButton({ content, className, ...props }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(content)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Button
      size="icon"
      onClick={handleCopy}
      className={cn(className)}
      {...props}
    >
      {copied ? (
        <CopiedCheck key="check" />
      ) : (
        <Copy className="animate-in zoom-in-20 duration-400" key="clipboard" />
      )}
    </Button>
  )
}


const CopiedCheck = () => {
  const ref = usePlayOnMount<CheckIconHandle>()
  return <CheckIcon ref={ref} size={16} className="pointer-events-none text-success" aria-hidden />
}
